import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp2-flying-ford-anglia-mystifies-muggles",
  name: `The Evening Prophet\n'Flying Ford Anglia Mystifies Muggles'`,
  nameFormatted: {
    primary: "The Evening Prophet",
    secondary: "'Flying Ford Anglia Mystifies Muggles'",
  },
  origin: "Harry Potter and the Chamber of Secrets",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
